export default {"src":"/_next/static/media/crab.7f1d0536.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};